import { useMutation, useQueryClient } from 'react-query';
import { BASE_API_URL } from '@env';

import { useUserStore } from '~providers/userStore/zustand';
export function useUpdateUserSubcategories() {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (userData: { ids: number[] }) => {
      const userId = useUserStore.getState().user?.uid;

      const token = useUserStore.getState().token;
      const response = await fetch(`${BASE_API_URL}users/${userId}/subcategories`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ ...userData }),
      });
      if (!response.ok) {
        throw new Error('Failed to update user subcategories');
      }

      return response.json() as Promise<string>;
    },
    { onSuccess: () => queryClient.refetchQueries(['userSubcategories']) },
  );

  return mutation;
}
